// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"89":"Logout","145":"RegistrationPage","260":"Configs","397":"AdminUsersPage","883":"LoginPage"}[chunkId] + "." + {"89":"4bb4aefa","145":"99bd35e3","260":"0b71677f","397":"1428bf22","883":"670e42ad"}[chunkId] + ".chunk.js";
};